import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import {
  Contents,
  Tab,
  Button,
  SeasonTab,
  Table,
  TableHeader,
  TableList,
  Empty
} from './styled';

const BaseballMatchRecordBattingTable = ({ data }) => {
  const [list, setList] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState('home');
  const [selectedTab, setSelectedTab] = useState('season');

  useEffect(() => {
    const seasonList = data[selectedTeam].seasonBatList;
    const vsList = data[selectedTeam].seasonVsBatList;

    if (selectedTab === 'season') {
      setList(seasonList);
    } else {
      setList(vsList);
    }
  }, [selectedTab, selectedTeam]);

  return (
    <Contents>
      <Tab>
        <Button
          className={clsx(selectedTeam === 'home' ? 'active' : '')}
          onClick={() => setSelectedTeam('home')}
        >
          {data.home.name}
        </Button>
        <Button
          className={clsx(selectedTeam === 'away' ? 'active' : '')}
          onClick={() => setSelectedTeam('away')}
        >
          {data.away.name}
        </Button>
      </Tab>
      <SeasonTab>
        <ul>
          <li className={clsx(selectedTab === 'season' && 'on')}>
            <button onClick={() => setSelectedTab('season')}>시즌</button>
          </li>
          <li>
            <div />
          </li>
          <li className={clsx(selectedTab === 'vs' && 'on')}>
            <button onClick={() => setSelectedTab('vs')}>vs 상대팀</button>
          </li>
        </ul>
      </SeasonTab>

      <Table>
        <TableHeader>
          <div className={'player'}>선수명</div>
          <div className={'avg'}>타율</div>
          <div className={'hit'}>안타</div>
          <div className={'rbi'}>타점</div>
          <div className={'ops'}>OPS</div>
        </TableHeader>
        {list.length > 0 ? (
          list.map((item, idx) => {
            return (
              <TableList key={item.player.id}>
                <div className={'player'}>{item.player.displayName}</div>
                <div className={'avg'}>{item.batAvg.toFixed(3)}</div>
                <div className={'hit'}>{item.batHit}</div>
                <div className={'rbi'}>{item.batRbi}</div>
                <div className={'ops'}>{item.batOps.toFixed(3)}</div>
              </TableList>
            );
          })
        ) : (
          <Empty>
            <div>타자 정보가 없습니다.</div>
          </Empty>
        )}
      </Table>
    </Contents>
  );
};

export default BaseballMatchRecordBattingTable;
